module.exports = __webpack_public_path__ + "img/Bpoint7.9c3231d2.png";